import React, { createContext, ReactNode } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import {
  UI_BUILD_HASH_PROPERTY,
  UI_BUILD_TAG_PROPERTY,
  UI_BUILD_TIME_PROPERTY,
} from '@erp/shared-utils';
import config from 'src/config';

const AnalyticsContext = createContext<null>(null);

interface AnalyticsProviderProps {
  children: ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  children,
}) => {
  return (
    <PostHogProvider
      apiKey={config.posthogApiKey}
      options={{
        api_host: config.posthogApiHost,
        autocapture: true, // Enable automatic event capture
        capture_exceptions: false, // right now sentry is handling exceptions
        debug: config.isDev,
        loaded: (posthog) => {
          posthog.register({
            [UI_BUILD_HASH_PROPERTY]: config.uiBuildHash,
            [UI_BUILD_TIME_PROPERTY]: config.uiBuildTime,
            ...(config.uiBuildTag && {
              [UI_BUILD_TAG_PROPERTY]: config.uiBuildTag,
            }),
          });
        },
      }}
    >
      <AnalyticsContext.Provider value={null}>
        {children}
      </AnalyticsContext.Provider>
    </PostHogProvider>
  );
};
